import { render, staticRenderFns } from "./InteractiveMatrixPage.vue?vue&type=template&id=b46c5464"
import script from "./InteractiveMatrixPage.vue?vue&type=script&lang=js"
export * from "./InteractiveMatrixPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports